//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import NavBar from "./components/NavBar.vue";
import Footer from "./components/Footer.vue";

export default {
  name: "app",
  components: {
    NavBar,
    Footer
  },
  data() {
    return {
      lang: "",
      loginSuc: false,
      title:"",
      path:"",//页面路径
      currency: 4,
    };
  },
  created() {
    document.title = this.$t('message.title')
    var cookie = document.cookie
    if(cookie.indexOf('curCurrency')>-1){
      var curCurrency = cookie.split('curCurrency=')[1].split(';')[0]

      this.currency = curCurrency
      // if(curCurrency){
      //   if(curCurrency==3){
      //     this.currency = 3
      //   }else{
      //     this.currency = 2
      //   }
      // }else{
      //   this.currency = 2
      // }
    }
  },
  methods: {
    currencyChangeApp(data){
      // console.log(data)
      this.currency = data
    },
    loginSuccess(data) {
      if (data == "true") {
        this.loginSuc = "true";
      }
    },
    changeLanguage(lang) {
      this.$i18n.locale = lang;
      this.lang = lang;
      document.title = this.$t('message.title')
    },
    changeAppLocale(locale) {
      this.changeLanguage(locale);
      // this.$router.push({name: this.$route.name, params: {lang: this.lang}})
    }
  },
  mounted() {
    // console.log(this.$route.params.lang);
    this.changeLanguage(this.$i18n.locale);
  }
};



// WEBPACK FOOTER //
// ./src/App.vue